import { Modal } from 'antd';
import React, { useEffect } from 'react';

export default function DeleteKeyModal({
  visible,
  setVisible,
  setTwoFaModalVisible,
  setActionId,
  selectedItemName,
  setActionKey,
}) {
  const handleOk = () => {
    setVisible(false);
    setTwoFaModalVisible(true);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event?.key === 'Enter' && visible) {
        event?.preventDefault();
        handleOk();
      }
    };

    // eslint-disable-next-line no-undef
    document?.addEventListener('keydown', handleKeyDown);
    return () => {
      // eslint-disable-next-line no-undef
      document?.removeEventListener('keydown', handleKeyDown);
    };
  }, [visible]);

  return (
    <Modal
      open={visible}
      centered
      title={
        <div className="d-flex" title={selectedItemName}>
          Delete '
          <div className="text-ellipsis modal-title"> {selectedItemName}</div>'
          key
        </div>
      }
      onOk={() => handleOk()}
      onCancel={() => {
        setActionKey(null);
        setVisible(false);
        setActionId(null);
      }}
      okText="Confirm"
    >
      Are you sure you want to permanently delete this key from all the
      environments? This action cannot be undone, and any services dependent on
      this key/s may be affected.
    </Modal>
  );
}
